import Image from "next/image"
import { twMerge } from "tailwind-merge"
import type { Article } from "@/components/resources/data/posts.types"

type AuthorProps = Article["author"]
const FALLBACK_PORTRAIT = "/android-chrome-192x192.png" as const

export function MiniAuthor({ firstname, lastname }: Pick<AuthorProps, "firstname" | "lastname">) {
  if (!firstname || !lastname) return null

  return (
    <p className="text-fg-secondary text-sm font-medium">
      {firstname} {lastname}
    </p>
  )
}

export function Author({
  image,
  firstname,
  lastname,
  nickname,
  title,
  isGuest,
  socials,
}: AuthorProps) {
  return (
    <>
      <div className="border-t border-neutral-800" />
      <div className="flex flex-col md:flex-row items-center gap-6">
        <Image
          src={image || FALLBACK_PORTRAIT}
          alt={nickname}
          width={96}
          height={96}
          className={twMerge("aspect-square shrink", image ? "rounded-full" : "")}
        />
        <div className="flex flex-col text-left gap-1">
          <h2 className="text-2xl font-medium text-fg-default">
            {firstname} {lastname}
          </h2>
          <p className="text-base font-medium text-fg-secondary">{title}</p>
          {isGuest ? (
            <div className="my-1 py-0.5 px-2 bg-neutral-100 text-neutral-900 font-medium rounded-md self-start">
              <span>Guest Contributor</span>
            </div>
          ) : null}
          {socials?.map((social) => (
            <p key={social.platform} className="text-fg-default">
              {social.platform}
            </p>
          ))}
        </div>
      </div>
      <div className="border-t border-neutral-800" />
    </>
  )
}
